import type { DeliverableType } from '@k2/domain/campaigns'
import { useApi } from '@/api'

export type ConceptType = Exclude<DeliverableType, 'story' | 'video'>

export const useConceptsResource = () => {
  const api = useApi()
  const conceptsOf = (organizationId: string, campaignId: string) =>
    api.api.v1.organizations({ organizationId }).campaigns({ campaignId }).concepts
  const conceptOf = (organizationId: string, conceptId: string) => api.api.v1.organizations({ organizationId }).concepts({ conceptId })

  return {
    getConcepts: (organizationId: string, campaignId: string) => conceptsOf(organizationId, campaignId).get(),
    setConcept: (organizationId: string, campaignId: string, type: ConceptType) => conceptsOf(organizationId, campaignId).post({ type }),
    setConceptDuplicate: (organizationId: string, conceptId: string) => conceptOf(organizationId, conceptId).duplicate.post(),
    delConcept: (organizationId: string, conceptId: string) => conceptOf(organizationId, conceptId).delete()
  }
}
